<template>
  <div>
    <v-btn
      color="rgb(0, 96, 99)"
      dark
      elevation="4"
      fixed
      bottom
      right
      class="mb-2"
      @click="openChatwoot()"
      style="z-index: 200"
    >
      <v-icon left>mdi-help-circle-outline</v-icon>Hilfe
    </v-btn>
  </div>
</template>

<script>
import { auth } from "@/firebase";

const HELPDESK_BASE_URL = (process.env.VUE_APP_CHATWOOT_BASE_URL || "").replace(
  /\/$/,
  "",
);
const HELPDESK_SCRIPT_URL = (
  process.env.VUE_APP_CHATWOOT_SCRIPT_URL || HELPDESK_BASE_URL
).replace(/\/$/, "");
const HELPDESK_WEBSITE_TOKEN = process.env.VUE_APP_CHATWOOT_WEBSITE_TOKEN || "";

export default {
  name: "help-widget",
  data() {
    return {
      helpdeskScriptPromise: null,
      helpdeskIdentityAppliedFor: null,
      authStateUnsubscribe: null,
    };
  },
  mounted() {
    this.authStateUnsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        this.helpdeskIdentityAppliedFor = null;
        if (window.$chatwoot) {
          window.$chatwoot.reset();
        }
      }
    });
  },
  beforeDestroy() {
    if (this.authStateUnsubscribe) {
      this.authStateUnsubscribe();
      this.authStateUnsubscribe = null;
    }
  },
  methods: {
    async openChatwoot() {
      try {
        await this.loadChatwootWidget();
        const helpdeskIdentity = this.getHelpdeskIdentity();

        await this.waitForChatwootReady();

        const identitySessionKey = helpdeskIdentity
          ? `${helpdeskIdentity.identifier}:${helpdeskIdentity.identifier_hash}`
          : null;

        if (
          helpdeskIdentity &&
          window.$chatwoot &&
          this.helpdeskIdentityAppliedFor !== identitySessionKey
        ) {
          window.$chatwoot.setUser(
            helpdeskIdentity.identifier,
            helpdeskIdentity,
          );
          this.helpdeskIdentityAppliedFor = identitySessionKey;

          if (
            helpdeskIdentity.customAttributes &&
            Object.keys(helpdeskIdentity.customAttributes).length > 0
          ) {
            window.$chatwoot.setCustomAttributes(
              helpdeskIdentity.customAttributes,
            );
          }
        }

        if (window.$chatwoot) {
          window.$chatwoot.toggle("open");
        }
      } catch (error) {
        console.error("Unable to open Chatwoot widget", error);
      }
    },

    loadChatwootWidget() {
      if (window.$chatwoot) {
        return Promise.resolve();
      }

      if (this.helpdeskScriptPromise) {
        return this.helpdeskScriptPromise;
      }

      if (!HELPDESK_BASE_URL || !HELPDESK_WEBSITE_TOKEN) {
        return Promise.reject(
          new Error("Missing Chatwoot configuration in environment variables"),
        );
      }

      window.chatwootSettings = {
        hideMessageBubble: true,
        position: "right",
        darkMode: "auto",
        locale: "de",
        showPopoutButton: true,
      };

      this.helpdeskScriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = `${HELPDESK_SCRIPT_URL}/packs/js/sdk.js`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          window.chatwootSDK.run({
            websiteToken: HELPDESK_WEBSITE_TOKEN,
            baseUrl: HELPDESK_BASE_URL,
          });
          resolve();
        };
        script.onerror = () => {
          this.helpdeskScriptPromise = null;
          reject(new Error("Failed to load Chatwoot"));
        };
        document.body.appendChild(script);
      });

      return this.helpdeskScriptPromise;
    },

    waitForChatwootReady() {
      if (window.$chatwoot) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        window.addEventListener("chatwoot:ready", () => resolve(), {
          once: true,
        });
      });
    },

    getHelpdeskIdentity() {
      const user = this.$store?.state?.user?.user || {};
      const helpdesk = user.helpdesk || {};
      const displayName = `${(user.firstName || "").trim()} ${(
        user.lastName || ""
      ).trim()}`.trim();

      if (!auth.currentUser || !helpdesk.identifierHash) {
        return null;
      }

      return {
        identifier: helpdesk.identifier || auth.currentUser.uid,
        identifier_hash: helpdesk.identifierHash,
        email: user.email || auth.currentUser.email || "",
        name: displayName || auth.currentUser.displayName || "",
        customAttributes: {
          appUid: auth.currentUser.uid,
          helpdeskContactId: helpdesk.contactId || null,
          accountType: user.meta?.accountType || null,
        },
      };
    },
  },
};
</script>
